import { useState } from "react";
import cx from "ui/cx";
import Select from "ui/forms/Select";
import ComponentSection from "ui/library/ComponentSection";
import styles from "./typography.module.scss";

const colorOptions = ["nonessential", "subdued", "foreground"];

export default function TypographyComponent() {
  const [color, setColor] = useState<(typeof colorOptions)[number]>("foreground");
  const typos: string[] = [
    "h1-bold",
    "h2-bold",
    "h3-bold",
    "h4-bold",
    "h4-book",
    "h5-bold",
    "h5-book",
    "h6-bold",
    "subtitle-book",
    "subtitle-medium",
    "subtitle2-book",
    "body-book",
    "body2-book",
    "body3-book",
    "body4-book",
  ];

  return (
    <ComponentSection>
      <header>
        <h5>Variants</h5>
        <label>
          Color
          <Select
            options={colorOptions.map((c) => ({ value: c, label: c }))}
            value={color}
            onChange={(e) => setColor(String(e))}
          />
        </label>
      </header>
      <div className={styles.typoStyles}>
        {typos.map((typo) => (
          <div key={typo} className={cx(styles[typo], color && styles[color])}>
            {typo}
          </div>
        ))}
      </div>
    </ComponentSection>
  );
}
